<template>
  <div class="apply-content">
    <div class="header">
      <img class="header-logo" :src="$store.state.static_img_url + 'pic/logo.png'" />
    </div>
    <div class="content">
      <p class="head-p">动脉橙机构版试用申请</p>
      <div class="one-desc">动脉橙机构版为企业、金融机构和政府提供更专业<br>全面的功能及服务。</div>
      <Form ref="apply-form" :model="params" label-position="top" :rules="form_rules">
        <FormItem label="关注的领域" prop="sel_ly">
          <Select v-model="params.sel_ly" multiple :max-tag-count="1">
            <Option :value="item" v-for="item,index in tag_list" :key="index">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem label="联系人" prop="name">
          <Input v-model="params.name" placeholder="请输入联系人" />
        </FormItem>
        <div class="nc-cnt" v-if="nc_status">
          <div id="nc"></div>
        </div>
        <FormItem label="手机号" prop="mobile" v-show="!nc_status">
          <Input v-model="params.mobile" placeholder="请输入联系电话" />
        </FormItem>
        <FormItem label="验证码" prop="code" class="code">
          <Input v-model="params.code" placeholder="请输入验证码"></Input>
          <Button v-if="code_status == 0" @click="getCode">获取验证码</Button>
          <Button v-if="code_status == 1" class="gray">验证中</Button>
          <Button v-if="code_status == 2" class="gray">{{wait}}s后重新获取</Button>
          <Button v-if="code_status == 3" @click="getCode">重新获取</Button>
        </FormItem>
        <FormItem label="公司或机构" prop="comp_name">
          <Input v-model="params.comp_name" placeholder="请输入公司或机构" />
        </FormItem>
        <FormItem label="职位" prop="title">
          <Input v-model="params.title" placeholder="请输入职位" />
        </FormItem>
        <FormItem label="需求">
          <Input v-model="params.summary" placeholder="请输入需求描述" />
        </FormItem>
      </Form>
    </div>
    <div class="footer">
      <button @click="submitForm">提交申请</button>
      <p>提交信息后，我们会在1~2个工作日审核，<br><span>虚假信息不予通过</span>，审核通过后，会与您取得联系，<br>请保持电话通畅。</p>
    </div>
  </div>
</template>
<script>
import { checkUserBehavior, addtryapplynew, addTryEnterPV } from '@/service'
export default {
  data() {
    return {
      tag_list: [
        '生物医药',
        '器械-应用科室',
        '器械-热门类别',
        '智慧医疗',
        '互联网+医疗健康',
        '数字疗法',
        '器械应用科室-IVD',
      ],
      params: {
        name: '',
        comp_name: '',
        title: '',
        summary: '',
        mobile: '',
        sel_ly: [],
        code: '',
      },
      form_rules: {
        name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            type: 'number',
            message: '手机号格式不正确',
            trigger: 'blur',
            transform(value) {
              let reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                return false
              } else {
                return Number(value)
              }
            },
          },
        ],
        comp_name: [{ required: true, message: '请输入公司或机构', trigger: 'blur' }],
        title: [{ required: true, message: '请输入职位', trigger: 'blur' }],
        summary: [{ required: true, message: '请输入需求描述', trigger: 'blur' }],
        sel_ly: [
          { required: true, type: 'array', min: 1, message: '请选择申请领域', trigger: 'change' },
        ],
      },
      code_status: 0, //0默认可点击 1点击 2等待 3重新获取
      nc_status: false,
      waitInterval: '',
      wait: 60,
    }
  },
  computed: {},
  beforeDestroy() {
    clearInterval(this.waitInterval)
    this.waitInterval = ''
  },
  methods: {
    async addTryEnterPV() {
      let res = await addTryEnterPV(
        {
          info_src: 31,
          userid: this.$store.state.user.id,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
    },
    getCode() {
      this.nc_status = false
      const _this = this
      this.$refs['apply-form'].validateField('mobile', (valid) => {
        if (!valid) {
          this.code_status = 1
          window.nvc.getNVCValAsync(function (nvcVal) {
            _this.checkUserBehavior(nvcVal)
          })
        }
      })
    },
    async checkUserBehavior(nvcVal) {
      let res = await checkUserBehavior(
        {
          data: nvcVal,
          mobile: this.params.mobile,
          scene: 'vbdata_try_enter',
        },
        (error) => this.$Message.error('请求错误！')
      )
      if (res.status == 'success') {
        if (res.code == 100 || res.code == 200) {
          this.code_status = 2
          this.waitInterval = setInterval(() => {
            this.wait--
            if (this.wait == 0) {
              this.code_status = 3
              this.wait = 60
              clearInterval(this.waitInterval)
            }
          }, 1000)
          this.nc_status = false
          this.$Message.success('验证码发送成功')
        } else if (res.code == 400) {
          this.nc_status = true
          var ncoption = {
            renderTo: 'nc',
          }
          this.$nextTick(() => {
            window.nvc.getNC(ncoption)
          })
        } else {
          this.code_status = 3
          this.$Message.error('验证被拦截，请稍后再试或联系客服')
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    submitForm() {
      this.$refs['apply-form'].validate(async (valid) => {
        if (valid) {
          let txt = this.params.sel_ly.join('，')
          let form_params = {
            user_key: this.$store.state.user_key || '',
            name: this.params.name,
            comp_name: this.params.comp_name,
            title: this.params.title,
            summary:
              '申请体验版块：“动态资讯库、产业知识库、行业数据库”；申请体验领域：“' +
              txt +
              '”。' +
              this.params.summary,
            info_src: 31,
            mobile: this.params.mobile,
            code: this.params.code,
            scene: 'vbdata_try_enter',
          }
          let res = await addtryapplynew(form_params, (error) => {
            this.$Message.error('请求失败！')
          })
          if (res.status == 'success') {
            this.$router.push({ name: 'MApplySuccess' })
          } else {
            this.$Message.error(res.message)
          }
        }
      })
    },
  },
  mounted() {
    const _this = this
    AWSC.use('nvc', function (state, module) {
      window.nvc = module.init({
        appkey: 'FFFF0N00000000009EB2',
        scene: 'nvc_other',
        success: function (data) {
          _this.checkUserBehavior(data)
        },
        fail: function (failCode) {
          window.console && console.log(failCode)
        },
        error: function (errorCode) {
          window.console && console.log(errorCode)
        },
      })
    })
    this.addTryEnterPV()
  },
}
</script>
<style lang="stylus" scoped>
.apply-content
  background #fff
  border solid #EEEEEE 0.5rem
  padding 0.3rem 0.3rem 0.4rem
  min-height 100vh
  .header
    border-bottom solid #EEEEEE 0.02rem
    padding-bottom 0.3rem
    text-align center
    font-size 0
    .header-logo
      width 1.48rem
      height 0.5rem
  .content
    .head-p
      color #333333
      font-size 0.28rem
      text-align center
      padding 0.3rem 0
    .one-desc
      font-size 0.24rem
      font-weight 500
      color #999
      line-height 0.36rem
      margin-top -0.06rem
      margin-bottom 0.3rem
      text-align center
    .nc-cnt
      width 300px
      height 34px
      margin -2px auto 18px
      >>> .nc_scale
        span
          box-sizing content-box
          &.nc-lang-cnt
            display inline !important
    .ivu-input, .ivu-select-selection, >>> .ivu-form-item
      margin-bottom 0.44rem
      .ivu-form-item-content
        line-height 1
          border 1px solid #DCDFE6
          border-radius 0.04rem
          font-size 0.24rem
        .ivu-form-item-error-tip
          padding-top 4px
      &.ivu-form-item-error
        .ivu-input, .ivu-select-selection
          border 1px solid #ed4014
      &.code
        .ivu-form-item-content
          position relative
          display flex
          justify-content space-between
          align-items center
          .ivu-input-wrapper
            width calc(100% - 2.2rem)
          .ivu-btn
            width 2rem
            border 0
            background #FA7F50
            box-shadow none
            outline none
            color #fff
            line-height 1
            font-size 0.24rem
            display flex
            align-items center
            justify-content center
            border-radius 0
            &.gray
              background #f0f0f0
              color #999
  .footer
    border-top solid #EEEEEE 0.02rem
    padding-top 0.4rem
    text-align center
    button
      width 2rem
      height 0.6rem
      background #FA7A50
      border-radius 0.04rem
      font-size 0.26rem
      font-weight 500
      color #FFFFFF
    p
      font-size 0.22rem
      font-weight 500
      color #999999
      line-height 0.36rem
      margin-top 0.3rem
      span
        color #ff9924
</style>